import Axios from "axios";
import CryptoJS from "crypto-js";
import store from "../store";

let BASE_URL = "https://kt.tgzzykj.cn/yy";
//let BASE_URL = "http://localhost:9028";
const SESSION_SECRET_URL = "/sdsp/appwx/index/session-secret";
const SIGNATURE_WHITE_LIST = ["/sdsp/wx/auth/code"];

let sessionId = "";
let sessionSecret = "";
let sessionOpenId = "";
let sessionSecretPromise = null;

Axios.interceptors.request.use(
  async (config) => {
    config.headers = config.headers || {};
    if (!config.headers["Content-Type"] && !config.headers["content-type"]) {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    if (store.state.Authorization) {
      config.headers.Authorization = store.state.Authorization;
    }
    if (!isCheckFlagEnabled(config.headers)) {
      return config;
    }

    await ensureSessionSecret();
    const timestamp = Date.now();
    const randomNum = Math.random().toString(36).substr(2, 15);
    const plainBody = JSON.stringify(config.data || {});
    const signature = generateSignature(plainBody, timestamp, randomNum, sessionOpenId);
    config.headers.Timestamp = timestamp;
    config.headers.Nonce = randomNum;
    config.headers.Signature = signature;
    config.headers["Session-Id"] = sessionId;
    config.headers["Open-Id"] = sessionOpenId;
    config.data = { encryptedData: encryptBody(plainBody) };

    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

export async function get(url, params) {
  return new Promise((resolve, reject) => {
    Axios.get(BASE_URL + url, {
      params: params,
    })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err.data);
      });
  });
}

async function ensureSessionSecret() {
  const openId = store.state.openId || "";
  if (!openId) {
    throw new Error("Missing openId for session secret");
  }
  if (sessionId && sessionSecret && sessionOpenId === openId) {
    return;
  }
  if (!sessionSecretPromise || sessionOpenId !== openId) {
    clearSessionSecret();
    sessionOpenId = openId;
    sessionSecretPromise = createRsaKeyPair()
      .then(({ privateKey, publicKey }) => Axios.post(BASE_URL + SESSION_SECRET_URL, { openId, publicKey })
        .then(async (res) => {
          const data = res.data && res.data.data;
          if (!data || !data.sessionId || !data.encryptedSessionSecret) {
            throw new Error("Invalid session secret response");
          }
          sessionId = data.sessionId;
          sessionSecret = await decryptSessionSecret(data.encryptedSessionSecret, privateKey);
          sessionOpenId = openId;
          return data;
        }))
      .finally(() => {
        sessionSecretPromise = null;
      });
  }
  return sessionSecretPromise;
}

async function createRsaKeyPair() {
  const keyPair = await window.crypto.subtle.generateKey(
    {
      name: "RSA-OAEP",
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: "SHA-1",
    },
    true,
    ["encrypt", "decrypt"]
  );
  const publicKeyBuffer = await window.crypto.subtle.exportKey("spki", keyPair.publicKey);
  return {
    privateKey: keyPair.privateKey,
    publicKey: arrayBufferToBase64(publicKeyBuffer),
  };
}

async function decryptSessionSecret(encryptedSessionSecret, privateKey) {
  const decryptedBuffer = await window.crypto.subtle.decrypt(
    { name: "RSA-OAEP" },
    privateKey,
    base64ToArrayBuffer(encryptedSessionSecret)
  );
  return new TextDecoder().decode(decryptedBuffer);
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary);
}

function base64ToArrayBuffer(base64) {
  const binary = window.atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

function generateSignature(plainBody, timestamp, randomNum, openId) {
  const signString = `${timestamp}&${randomNum}&${openId}&${plainBody}&key=${sessionSecret}`;
  const hash = CryptoJS.HmacSHA256(signString, sessionSecret);
  return CryptoJS.enc.Base64.stringify(hash);
}

function encryptBody(plainBody) {
  const key = CryptoJS.enc.Utf8.parse(sessionSecret);
  return CryptoJS.AES.encrypt(plainBody, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
}

function isCheckFlagEnabled(headers) {
  return String(headers && headers["check-flag"]).toLowerCase() === "true";
}

function isSignatureWhiteUrl(url) {
  return SIGNATURE_WHITE_LIST.some((whiteUrl) => url.indexOf(whiteUrl) !== -1);
}

export function clearSessionSecret() {
  sessionId = "";
  sessionSecret = "";
  sessionOpenId = "";
  sessionSecretPromise = null;
}

export async function post(url, params) {
  const body = params || {};
  return new Promise((resolve, reject) => {
    const config = isSignatureWhiteUrl(url) ? {} : { headers: { "check-flag": "true" } };
    Axios.post(BASE_URL + url, body, config)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err.data);
      });
  });
}

export async function upload(url, params) {
  return new Promise((resolve, reject) => {
    let config = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    Axios.post(url, params, config)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err.data);
      });
  });
}
